<template>
  <button-dropdown :infos="infos" :defaultOption="actualField" @change="changeOrder"/>
</template>

<script>
  import ButtonDropdown from '@/components/template/ButtonDropdown'

  export default {
    data: () => ({
      infos: {
        label: 'ordering',
        identifier: 'sort-select',
        icon: 'icon-sort-alpha-asc',
        order: 'asc',
        value: '',
        options: null
      },
      actualField: '',
      actualOrder: '',
      created: false
    }),
    props: {
      fields: {
        type: Array,
        required: true,
        validator: value => value.length > 0
      },
      fieldDefault: {
        type: String,
        required: false
      },
      sortDefault: {
        type: String,
        required: false
      }
    },
    created () {
      this.infos.options = this.fields

      if (this.sortDefault) {
        this.infos.order = this.sortDefault
      }
      if (this.fieldDefault) {
        this.infos.value = this.fieldDefault
      } else {
        this.infos.value = this.fields[0]
      }
      this.actualField = this.infos.value
      this.actualOrder = this.infos.order
    },
    methods: {
      changeOrder (field) {
        this.created = true
        this.$emit('change', field, this.infos.order)
        this.actualOrder = this.infos.order
        this.infos.order = this.infos.order === 'asc' ? 'desc' : 'asc'
        this.actualField = field
      }
    },
    watch: {
      actualOrder () {
        this.infos.icon = 'icon-sort-alpha-' + this.actualOrder
      }
    },
    components: {
      ButtonDropdown
    }
  }
</script>



// WEBPACK FOOTER //
// SortSelect.vue?c838edfe